module.exports = __webpack_public_path__ + "img/26.4c40b2f5.jpg";